export const environment = {
	API_URL: '',
	BUVApiUrl: 'https://buv-dev.menhir.com.ar',
	callejeroUrl: 'https://buv-dev.menhir.com.ar/geoapi',
	autenticarUrl: 'https://identidadvl.vicentelopez.gov.ar/autenticar/redirect',
	afipUrl: 'https://identidadvl.vicentelopez.gov.ar/autenticar/redirect/afip',

	keycloakServer: 'https://kc.menhir.com.ar',
	keycloakClientId: 'dev-client',
	keycloakRealm: 'BUV',

	faqURL : "https://www.vicentelopez.gov.ar/identidaddigitalvl-preguntas-frecuentes",
	rootURL: 'https://tramitesvl.vicentelopez.gov.ar/',
};
